import { readonly, ref, toRaw, watch } from "vue";
import { useRoute } from "vue-router";

const useRouterQuery = (...callbacks: ((...args: any[] | undefined) => Promise<any> | void)[]) => {
  const route = useRoute();
  if (!route?.query) return;

  const query = ref(route?.query);

  watch(
    () => route.query,
    (newQuery) => {
      query.value = newQuery;

      if (!callbacks.length) return;
      (async () => {
        for (const callback of callbacks) {
          await callback(newQuery);
        }
      })();
    },
    { immediate: true }
  );

  return {
    query: toRaw(readonly(query.value))
  };
};

export default useRouterQuery;
